"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPageView } from "@/utils/gtm";

export default function usePageTracking(): void {
  const pathname = usePathname();

  // Next.js Pages Router support (routeChangeComplete)
  useEffect(() => {
    if (typeof window === "undefined") return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let routerEvents: any;
    try {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const nextRouter = require("next/router");
      routerEvents = nextRouter?.default?.events || nextRouter?.Router?.events;
    } catch {
      routerEvents = null;
    }

    if (!routerEvents?.on || !routerEvents?.off) return;

    const onRouteChangeComplete = (url: string) => {
      trackPageView(url);
    };

    routerEvents.on("routeChangeComplete", onRouteChangeComplete);
    return () => {
      routerEvents.off("routeChangeComplete", onRouteChangeComplete);
    };
  }, []);

  // Next.js App Router fallback (pathname changes)
  useEffect(() => {
    if (!pathname) return;
    trackPageView(pathname);
  }, [pathname]);
}

